import { render, staticRenderFns } from "./CoverYearsView.vue?vue&type=template&id=7e484e80&scoped=true"
import script from "./CoverYearsView.vue?vue&type=script&lang=js"
export * from "./CoverYearsView.vue?vue&type=script&lang=js"
import style0 from "./CoverYearsView.vue?vue&type=style&index=0&id=7e484e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e484e80",
  null
  
)

export default component.exports